import { __assign } from "tslib";
import { createFakeGetResponder } from './../../../test-utils';
import { createSeoApi, seoApiRelativePath } from './index';
import { createFakePostResponder } from '../../../test-utils';
import { createHttpTestKit } from '../../../http/test-kit';
export var createSeoApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createSeoApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetPageSeo: function (dto) {
            return createFakeGetResponder(fakeHttp, seoApiRelativePath + "/" + dto.type + "/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        whenUpdatePageSeo: function (dto) {
            return createFakePostResponder(fakeHttp, seoApiRelativePath + "/" + dto.type + "/" + dto.locale)(dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map